import BaseComponent from "components/base-component"
import classNames from "classnames"
import {CourseModule} from "models"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default class ComponentsCourseModulesLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    courseModule: PropTypes.instanceOf(CourseModule).isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, courseModule, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--course-modules--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || courseModule.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || courseModule.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, courseModule} = this.p

    if (adminLayout) return Routes.adminCourseModulePath(courseModule.id())
  }
}
